class CustomSelect {
    constructor (element) {
        if( !element ) return

        this.expanded = false
        
        this.toggle = this.toggle.bind(this)
        this.cacheDom(element)
        this.bind()
    }

    show() {
        this.root.classList.add('is-expanded')
        this.expanded = true
    }
    
    hide() {
        this.root.classList.remove('is-expanded')
        this.expanded = false
    }

    toggle() {
        this.expanded
            ? this.hide()
            : this.show()
    }
    
    cacheDom(element) {
        this.root = element
        this.selector = this.root.querySelector('[data-selector]')
        this.options = this.root.querySelector('[data-select-options]')
    }

    bind() {
        this.selector.addEventListener('click', this.toggle)
    }
}

export default CustomSelect